// extracted by mini-css-extract-plugin
module.exports = {"detailStyle":"JTK6sIu2itCj14uCE0_s2"};